<script setup lang="ts">
  import { useDisplay } from "vuetify";

  interface Props {
    page: number;
    totalPages: number;
  }
  interface Emits {
    (event: "update:page", page: number): void;
  }
  const props = defineProps<Props>();
  const emit = defineEmits<Emits>();

  const computedPage = computed<number>({
    get: () => props.page,
    set: value => {
      emit("update:page", value);
    },
  });
  const totalVisible = computed<number>(() =>
    props.page <= 3 || props.page >= props.totalPages - 2 ? 5 : 6,
  );
  const { name } = useDisplay();
  const isNotSp = computed<boolean>(() => name.value !== "xs");
</script>

<template>
  <div class="text-center contents-pagination">
    <v-pagination v-model="computedPage" :length="totalPages" :total-visible="totalVisible">
      <template v-if="isNotSp" #prev="prevProps">
        <div class="d-flex align-center h-100 mr-1" style="width: 112px">
          <v-btn
            class="text-content-detail-m font-weight-bold pagination-btn"
            variant="outlined"
            block
            rounded="4"
            size="small"
            height="30"
            :disabled="prevProps.disabled"
            @click="prevProps.onClick"
          >
            前のページへ
          </v-btn>
        </div>
      </template>
      <template v-if="isNotSp" #next="nextProps">
        <div class="d-flex align-center h-100 ml-1" style="width: 112px">
          <v-btn
            class="text-content-detail-m font-weight-bold pagination-btn"
            variant="outlined"
            block
            rounded="4"
            size="small"
            height="30"
            :disabled="nextProps.disabled"
            @click="nextProps.onClick"
          >
            次のページへ
          </v-btn>
        </div>
      </template>
    </v-pagination>
  </div>
</template>

<style lang="scss">
  .contents-pagination {
    .v-pagination {
      &__item {
        margin: 0.2rem;

        &--is-active .v-btn {
          opacity: 1;
          background-color: rgb(var(--v-theme-main-01));
        }
      }

      .v-btn {
        max-width: 10vw;
        max-height: 10vw;

        &[ellipsis="true"] {
          max-width: 6vw;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>
  .contents-pagination {
    .pagination-btn[disabled] {
      display: none;
    }
  }
</style>
